var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }